import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleKiloleterMasterRemove } from "../../../Api/api";

export const removeKiloleterMasterAsync = createAsyncThunk(
   "kiloleterMaster/remove",
   async ({ id, done, err }) => {
      try {
         const response = await handleKiloleterMasterRemove(id);
         done && done();
         return response.data;
      } catch (error) {
         const errorMessage =
            error?.response?.data?.message || "Failed to delete Kiloleter";

         err && err(errorMessage);
         throw error?.response?.data || errorMessage;
      }
   }
);




